import { Injectable } from '@angular/core';
import { ParkingZone, ParkingZoneDto } from '../../models/parking/parking-zone.model';

@Injectable({
  providedIn: 'root'
})
export class MapperParkingZoneService {
  constructor() { }

  public mapFromDto(dto: ParkingZoneDto): ParkingZone {
    return {
      id: dto.id || 0,
      name: dto.name || '',
      floor: dto.floor || '',
      parkingType: dto.parkingType || '',
      lot: dto.lot || 0,
      isOnline: !!dto.isOnline
    };
  }

  public mapToDto(model: ParkingZone): ParkingZoneDto {
    return {
      id: model.id,
      name: model.name,
      floor: model.floor,
      parkingType: model.parkingType,
      lot: model.lot,
      isOnline: model.isOnline
    };
  }
}
